import Vue from 'vue';

function initCredentialoverview() {

    if (document.querySelector('.credential__overview')) {
        new Vue({
            name: 'ContentCredentials',
            el: '.credential__overview',
            components: {

            },
            data: {
                mobileActiveTemp: '',
                mobileFilter: false,
                credentials: credentials,
                locations: locations,
                filters: filters,
                countrys: countrys,
                additional: additional,
                products: products,
                activeItems: [],
                activeItemsFilltered: [],
                activeFilters: [],
                maxItems: 9,
                maxFound: 0,
                opened: undefined,
                buttonActive: false,
            },
            methods: {
                setActive: function () {
                    console.log('start setActive()');
                    var self = this;
                    self.activeItemsFilltered = [];
                    self.activeItemsTemp = [];
                    self.credentials.forEach(function(item, index){
                        var tempArray = {
                            'id' : item['id'],
                            'productTitle' : item['productTitle'],
                            'is360' : item['is360'],
                            'name' : item['name'],
                            'location' : item['location'],
                            'place' : item['place'],
                            'additional' : item['additional'],
                            'url' : item['url'],
                            'mediaUrl' : item['mediaUrl']
                        }
                        self.activeItemsTemp.push(tempArray);
                    });
                    self.activeItems = self.activeItemsTemp;
                    if(self.activeFilters.length == 0){

                    }else{
                        self.activeFilters.forEach(function(item){
                            self.activeItemsTemp = [];
                            var filterId = item['value'];
                            var filterType = item['filter'];
                            self.activeItems.forEach(function(item){
                                if(self.returnIsInFilter(filterId, item[filterType])){
                                    var tempArray = {
                                        'id' : item['id'],
                                        'productTitle' : item['productTitle'],
                                        'is360' : item['is360'],
                                        'name' : item['name'],
                                        'location' : item['location'],
                                        'place' : item['place'],
                                        'additional' : item['additional'],
                                        'url' : item['url'],
                                        'mediaUrl' : item['mediaUrl']
                                    }
                                    self.activeItemsTemp.push(tempArray);
                                    console.log('pushedintemp');
                                }else{

                                }
                            });
                            self.activeItems = self.activeItemsTemp;
                        });
                    }
                    self.maxFound = self.activeItems.length;
                    self.activeItems.forEach(function(item, index){
                        self.activeItems = self.activeItemsTemp;
                        if(self.maxItems > index){
                            var tempArray = {
                                'id' : item['id'],
                                'productTitle' : self.setProductTitles(item['productTitle']),
                                'is360' : item['is360'],
                                'name' : item['name'],
                                'location' : self.returnItemName(item['location'],self.locations),
                                'place' : self.returnItemName(item['place'],self.countrys),
                                'additional' : self.returnItemName(item['additional'],self.additional),
                                'url' : item['url'],
                                'mediaUrl' : item['mediaUrl']
                            }
                            self.activeItemsFilltered.push(tempArray);
                        }else{

                        }
                    });
                },
                returnItemName: function (id, array) {
                    var itemName = '';
                    array.forEach(function(item){
                        if(item['id'] == id){
                            itemName = String(item['name']);
                        }
                    });
                    return itemName;
                },
                returnIsInFilter: function(filterId, array)
                {
                    var inFilter = false;
                    if (Array.isArray(array)) {
                        array.forEach(function (item) {
                            console.dir(item);
                            if (filterId == item) {
                                inFilter = true;
                            }
                        });
                    }
                    else
                    {
                        if (filterId == array)
                        {
                            inFilter = true;
                        }
                    }
                    return inFilter;
                },
                setActiveFilter: function (filterId, filter) {
                    var self = this;
                    if (filter == 'is360'){
                        this.buttonActive = true;
                    }
                    if(filter == 'all'){
                        self.activeFilters = [];
                        self.setActive();
                    }else{
                        if (filterId == null)
                        {
                            self.closeActiveFilter(filter);
                        }
                        else {
                            var tempArray ={
                                'filter' : filter,
                                'value' : filterId,
                            }
                            var itemsProcessed = 0;
                            if(self.activeFilters.length == 0){
                                self.activeFilters.push(tempArray);
                                self.setActive();
                            }else{
                                self.activeFilters.forEach(function(item,index){
                                    if(item['filter'] == filter){
                                        self.activeFilters[index]['value'] = filterId;
                                        self.setActive();
                                        return true;
                                    }
                                    itemsProcessed++;
                                    if(itemsProcessed === self.activeFilters.length) {
                                        self.activeFilters.push(tempArray);
                                        self.setActive();
                                    }
                                });
                            }
                        }
                    }
                },
                getFilterIndex: function (array, name) {
                    let self = this;
                    let mobileActiveTempIndex = null;
                    if(array != null && array.length){
                        array.forEach(function(item, index){
                            if(item['name'] == name){
                                mobileActiveTempIndex = item['id'];
                            }
                        });
                    }
                    return mobileActiveTempIndex;
                },
                closeActiveFilter: function (filter) {
                    var self = this;
                    if (filter == 'is360'){
                        this.buttonActive = false;
                    }
                    self.activeFilters.forEach(function(item, index){
                        if(item['filter'] == filter){
                            self.activeFilters.splice(index,1);
                        }else{

                        }
                    });
                    self.setActive();
                },
                loadMore: function () {
                    var self = this;
                    self.maxItems = self.maxItems + 9;
                    this.setActive();
                },
                closeDropdown: function(){
                    this.opened = undefined;
                },
                openDropdown: function(index){
                    index == this.opened ? this.opened = undefined : this.opened = index; this.mobileActiveTemp = this.filters[index].active;
                },
                setProductTitles: function(titles){
                    let self = this;
                    var tempArray = [];
                    titles.forEach(function(item){
                        self.products.forEach(function(product_item)
                        {
                            if (product_item.id == item)
                            {
                                tempArray.push(product_item.name);
                            }
                        });
                    });
                    return tempArray;
                },
                openReference: function(url, is360, event)
                {
                    if (is360 == 1)
                    {
                        event.preventDefault();
                        var playerFrame = document.getElementById('reference360-player-frame');
                        var player = document.getElementById('reference360-player');
                        var playersControl = document.getElementById('reference360-playercontrols');
                        playerFrame.setAttribute('src', url)
                        setTimeout(function()
                        {
                            player.classList.remove('d-none')
                            player.classList.add('d-flex');
                        }, 500);
                        playersControl.addEventListener("click", function(e){
                            player.classList.remove('d-flex');
                            player.classList.add('d-none');
                        })
                    }
                },
            },
            mounted() {
                this.setActive();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    initCredentialoverview();
});
window.addEventListener("Pageeditor:insert", function() {
    initCredentialoverview();
});
window.addEventListener("Pageeditor:change", function() {
    initCredentialoverview();
});
window.addEventListener("Pageeditor:move", function() {
    initCredentialoverview();
});